import axios from "@/utils/axios";

export const getDashboardSummary = async () => {
  const response = await axios.get("/dashboard");
  return response.data;
};

export const getDashboardKPIs = async () => {
  const response = await axios.get("/dashboard/kpis");
  return response.data;
};

export const getDashboardClientStats = async () => {
  const response = await axios.get("/dashboard/clients");
  return response.data;
};

export const getDashboardFactureStats = async () => {
  const response = await axios.get("/dashboard/factures");
  return response.data;
};

export const getDashboardRecentActivity = async () => {
  const response = await axios.get("/dashboard/activity");
  return response.data;
};

export const getDashboardAbonnementStats = async () => {
  const response = await axios.get("/dashboard/abonnement");
  return response.data;
};

export const getDashboardOperations = async () => {
  const response = await axios.get("/dashboard/operations");
  return response.data;
};

export const getDashboardFinancials = async () => {
  const response = await axios.get("/dashboard/financials");
  return response.data;
};

export const getDashboardTopClients = async () => {
  const response = await axios.get("/dashboard/top-clients");
  return response.data;
};

export const getDashboardStockAlerts = async () => {
  const response = await axios.get("/dashboard/stock-alerts");
  return response.data;
};
